import actionTypes from '../actions/action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_SUBORDINATE_LIST_SUCCESS:
      return [...action.list];
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-subordinates/reducers/subordinate-list.js